import { createContext } from 'react'

const gatsbyi18Context = createContext({
  language: null,
})

export default gatsbyi18Context
